export var EXPORT_MIME = {
    png: 'image/png',
    jpeg: 'image/jpeg',
    svg: 'image/svg+xml',
    pdf: 'application/pdf',
    json: 'application/json',
    html: 'text/html',
};
